import React from 'react'
import moment from 'moment'
import { PostContext, useChatContext } from 'APP/Lib/Context'
import Post from 'APP/Components/Chat/Post'

import { TYPING_INDICATOR_UNIQUE_ID, TYPING_INDICATOR_UNIQUE_PROPS_TYPE } from './constants'
import type { TypingIndicatorFakePost } from './types'

export const TypingIndicator = () => {
  const { users, channelId, episode, lastPost, userId, typingEvent, orderedPosts } =
    useChatContext()

  const isTyping = typingEvent?.broadcast?.channel_id === channelId

  if (!isTyping || !episode) return null

  const postUser = users.find((u) => Number(u.app_id) === episode.assigneeId)
  const previousPost = orderedPosts.length >= 1 && orderedPosts[0]
  const previousPostIsCp = lastPost?.user_id !== userId

  const previousPostIsSameDay = previousPost
    ? moment(Date.now()).isSame(previousPost?.create_at, 'day')
    : false

  return (
    <PostContext.Provider
      key={TYPING_INDICATOR_UNIQUE_ID}
      value={{
        post: {
          id: TYPING_INDICATOR_UNIQUE_ID,
          create_at: Date.now(),
          user_id: postUser?.id,
          // @ts-expect-error FIXME: make this required for the ChatContext upstream
          channel_id: channelId,
          props: { type: TYPING_INDICATOR_UNIQUE_PROPS_TYPE },
        } satisfies TypingIndicatorFakePost,
        postUser,
        isMember: false,
        previousPostIsSameUser: previousPostIsCp,
        nextPostIsSameUser: false,
        previousPostIsSameDay,
        nextPostIsSameDay: false,
        encounter: undefined,
        isLastPost: true,
      }}
    >
      <Post />
    </PostContext.Provider>
  )
}
